import { createFileRoute } from '@tanstack/react-router';
import { TemplatesPage } from '@/features/shifts/pages/templates-page';

export const Route = createFileRoute('/_app/shifts/templates')({ component: TemplatesPage });
